module.exports = __webpack_public_path__ + "static/media/logo-white.56dfca5e.png";